
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  section: 'Virtual Accounts',
  title: 'Account Sweeping',
  description: 'Sweep funds from your virtual account'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Callout = makeShortcode("Callout");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title={metadata.title} subtitle={metadata.description} mdxType="Header" />
    <p>{`Account sweeping periodically sweeps the available balance of a virtual account to a designated client-owned bank account. By default, automated account sweeping is not enabled.`}</p>
    <p>{`Sweeping funds ensures you control how much balance you maintain in your virtual account. If a virtual account used for refunds or payouts also has account sweeping enabled, there may be requests that fail whenever a virtual account does not have sufficient funds.`}</p>
    <h4 {...{
      "id": "sweep-funds-from-a-virtual-account"
    }}>{`Sweep funds from a Virtual Account`}</h4>
    <p>{`Make sure your virtual account is set up before following these steps. For more information on setting up an account, see `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/virtual-accounts/managing-virtual-accounts"
      }}>{`Managing virtual accounts`}</a>{`.`}</p>
    <p>{`There are two ways you can sweep funds from your virtual account:`}</p>
    <h5 {...{
      "id": "automated"
    }}>{`Automated`}</h5>
    <Callout mdxType="Callout">
      <p>{`Automated sweeps are the preferred sweep method for pay-by-bank and pay-in use cases. If your wallet is set up primarily for payouts, you should not enable automated sweeping, as you need to maintain funds in your wallet balance in order to issue payouts. `}</p>
    </Callout>
    <p>{`For each virtual account you want automated account sweeping to be enabled for, provide your account manager with:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`The virtual account's `}<inlineCode parentName="p">{`wallet_id`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The account details for the designated account which funds should be swept to.`}</p>
      </li>
    </ul>
    <p>{`The available balance of each virtual account will be swept once a day at 12:00 AM UTC indefinitely. Once your automated sweeping is set up, you can configure it within the Plaid Dashboard. `}</p>
    <p>{`In the UK, if the sweep amount is over the Faster Payments £1M limit, the sweep will be sent via CHAPS. CHAPS payments are only processed on UK business days (excluding bank holidays), between 8:00 AM and 5:00 PM (08:00–17:00), UK local time.`}</p>
    <h5 {...{
      "id": "manual"
    }}>{`Manual`}</h5>
    <p>{`If you prefer to manually control account sweeping, you will need to manually `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/virtual-accounts/payouts/"
      }}>{`execute a Payout`}</a>{` each time you want to sweep funds.`}</p>
    <h4 {...{
      "id": "sweep-requirements"
    }}>{`Sweep requirements`}</h4>
    <p>{`When a sweep occurs, all transactions since the last sweep will be included in the sweep. For a sweep to occur, your account balance must be above the minimum balance. If this is not the case, no sweep will occur, and any unswept transactions will be rolled into the next sweep. `}</p>
    <h4 {...{
      "id": "sweep-reporting"
    }}>{`Sweep reporting`}</h4>
    <p>{`Sweep reporting enables you to know exactly which transactions are included in any given sweep. This helps improve reconciliation and avoid issues where transactions occur during the processing of the sweep. Sweep reporting is available for automated sweeps only.`}</p>
    <p>{`You can find your sweep reports at `}<strong parentName="p">{`Plaid Dashboard > Payments > Accounts > Sweeps`}</strong>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://plaid.com/documents/sample-sweep-report.csv"
      }}>{`See an example sweep report`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "sweep-funds-from-a-virtual-account",
        level: 4,
        title: "Sweep funds from a Virtual Account",
      },
{
        id: "sweep-requirements",
        level: 4,
        title: "Sweep requirements",
      },
{
        id: "sweep-reporting",
        level: 4,
        title: "Sweep reporting",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
